module.exports = __webpack_public_path__ + "img/chromagear.fb4222c5.png";